import axios from 'axios';

class GlobalService {
  constructor() {
    this.baseUrl = process.env.GATSBY_NEW_BOOKING_API;
    this.axios = axios.create({
      baseURL: this.baseUrl,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getQueryString(queryArray) {
    if (!Array.isArray(queryArray)) return '';

    return queryArray.reduce((queryString, keyAndValue) => {
      if (!Array.isArray(keyAndValue) || keyAndValue.length !== 2) return '';

      const [key, value] = keyAndValue;
      return `${queryString === '?' ? queryString : queryString + '&'}${key}=${value}`;
    }, '');
  }

  getEndpointUrl({ path = '/', query = [] } = '') {
    if (typeof arguments[0] === 'string') return arguments[0];
    let currentBaseUrl = this.baseUrl;

    if (path === '/profile') currentBaseUrl = currentBaseUrl.replace('v1', 'v2');

    return `${currentBaseUrl}${path}${this.getQueryString(query)}`;
  }
}

export default GlobalService;
